import { Typography, Sheet } from "@mui/joy";
import { useTheme } from "@mui/joy/styles";
import { NavItemDisplay } from "./NavMenu";
import React from "react";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { SxProps } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";

interface NavItemProps {
	item: NavItemDisplay;
	selected: boolean;
}

export default function NavItem(props: NavItemProps) {
	const theme = useTheme();
	const [over, setOver] = React.useState(false);
	const textSx: SxProps = { color: theme.palette.background.level2, display: "block" };
	const sheetSx: SxProps = {
		pr: 2,
		pl: 4,
		py: 1,
		textAlign: "left",
		backgroundColor: (theme.palette.background as any).navMenu,
		cursor: "pointer",
		"&:hover": {
			backgroundColor: "black",
		},
		span: {
			float: "right",
		},
		position: "relative",
	};
	if (props.selected) {
		sheetSx["borderLeftWidth"] = theme.spacing(1);
		sheetSx["borderLeftColor"] = theme.palette.success[400];
		sheetSx["borderLeftStyle"] = "solid";
	}

	if (props.item.Route === "/logout") sheetSx["marginTop"] = "auto";
	const n = useNavigate();

	const onNav = (item: NavItemDisplay) => {
		if (item.ChildItems) {
			onNav(item.ChildItems[0]);
			return;
		}

		if (item.Route) {
			n(item.Route);
		}
	};
	return (
		<Sheet
			sx={sheetSx}
			onMouseEnter={() => {
				setOver(true);
			}}
			onMouseLeave={() => {
				setOver(false);
			}}
			onClick={(event) => {
				event.preventDefault();
				event.stopPropagation();
				onNav(props.item);
			}}>
			<Typography level="body-sm" fontWeight={props.selected ? 600 : 300} sx={textSx} endDecorator={props.item.ChildItems && props.item.ChildItems.length > 0 ? <KeyboardArrowRightIcon sx={{ float: "right" }} style={{ float: "right" }} /> : <></>}>
				{props.item.Display} {props.item.Route === "/logout" && <LogoutIcon sx={{ verticalAlign: "text-bottom" }} />}
			</Typography>
			{props.item.ChildItems && (
				<Sheet sx={{ position: "absolute", width: "200px", visibility: over ? "visible" : "hidden", backgroundColor: "green", height: "20px", top: 0, left: "100%", display: "block", zIndex: 90 }}>
					{props.item.ChildItems.map((x) => (
						<NavItem item={x} selected={false}></NavItem>
					))}
				</Sheet>
			)}
		</Sheet>
	);
}
